import FlightsPage from "./pages/FlightsPage";

function App() {
  return (
      <div className="App">
        <div className="container">
          <FlightsPage/>
        </div>
      </div>
  );
}

export default App;
